import CompanyInfo from "./CompanyInfo.js";
import Group from "./Group.js";
import Telegram from "../../assets/Telegram.svg";
import RuStore from "../../assets/App Markets/RuStore.js";
import GooglePlay from "../../assets/App Markets/GooglePlay.js";
import AppStore from "../../assets/App Markets/AppStore.js";

export default function Footer() {
  return (
    <footer className="w-full md:px-[24px] tracking-normal md:-tracking-[3%] overflow-hidden">
      <div className="md:max-w-[1200px] w-fit md:w-full mx-auto pt-[80px] md:pt-[71px] pb-[60px] md:pb-[130px] flex flex-col md:flex-row items-center md:items-start gap-x-[10px] lg:gap-x-[20px] gap-y-[32px]">
        <CompanyInfo containerClassName="hidden md:flex" />

        <Group
          title="Помощь"
          contentClassName="flex flex-col gap-[8px] font-medium text-[15px] leading-[23px] text-[#8C8C8C]"
        >
          <a href="/">О нас</a>
          <a href="/terms-of-service">Публичная оферта</a>
          <a href="/privacy-policy">Политика конфиденциальности</a>
        </Group>

        <Group title="Контакты" contentClassName="flex flex-col gap-[16px]">
          <a
            href="mailto:support@sobesednikai.ru"
            className="text-[15px] leading-[21px] tracking-normal text-[#8C8C8C]"
          >
            support@sobesednikai.ru
          </a>
          <div className="flex gap-[10px] justify-center md:justify-start">
            <a
              href="https://t.me/sobesednik_supportbot"
              target="_blank"
              rel="noopener noreferrer"
              className="w-[32px] h-[32px] flex items-center justify-center"
            >
              <img
                src={Telegram}
                alt="Telegram"
                className="w-[24px] h-[24px]"
              />
            </a>
          </div>
        </Group>

        <Group
          title="Мобильное приложение"
          contentClassName="flex flex-col gap-[12px]"
        >
          <a
            href="https://www.rustore.ru/catalog/app/com.sobesednik.ai"
            target="_blank"
            rel="noopener noreferrer"
          >
            <RuStore />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.sobesednik.ai"
            target="_blank"
            rel="noopener noreferrer"
          >
            <GooglePlay />
          </a>
          <a
            href="https://apps.apple.com/us/app/собеседник-ии/id6755813097"
            target="_blank"
            rel="noopener noreferrer"
          >
            <AppStore />
          </a>
        </Group>

        <CompanyInfo containerClassName="flex md:hidden" />
      </div>
    </footer>
  );
}
